import React from "react";
import { FileText } from "lucide-react";
import Card from "./Card";
import { displayValue } from "./utils";
import textTranslator from "../../../../utils/useTextTranslator";
import Txt from "../../../Text";

const Text = ({ children, className, page = "APPOINTMENTS" }) => {
	return (
		<Txt page={page} className={className} keyName={page}>
			{children}
		</Txt>
	);
};

const AppointmentNotesCard = ({ appointment, darkMode, arClass }) => {
	const notes = appointment?.notes || appointment?.description || "-";

	return (
		<Card
			title={textTranslator("Notes", "APPOINTMENTS")}
			subtitle={textTranslator("Appointment Notes", "APPOINTMENTS")}
			icon={FileText}
			darkMode={darkMode}
			arClass={arClass}
		>
			<div className={`rounded-lg p-4 ${darkMode ? "bg-gray-800/50 border-white/10" : "bg-slate-50 border-slate-100"} border`}>
				<p className={darkMode ? "text-gray-200 whitespace-pre-wrap" : "text-slate-700 whitespace-pre-wrap"}>
					{displayValue(notes)}
				</p>
			</div>
		</Card>
	);
};

export default AppointmentNotesCard;
